import {addOpacityOnSceneChanges, AutoVideEffect, fadeEffect, makeScreenshot} from "service/exportVideoEffects";
import HelpService from './help.service';
import VideoRecorder from '../videorecorder';
import ProtobufCommonService from 'a_common-folder/services/protobuf.service';
import {createSilentAudio} from 'create-silent-audio';
import {sendFrames} from 'lib/helpers/common';
import {cutMp3, repeatMp3} from 'lib/service/ffmpeg';
import {BACKGROUND_AUDIO} from 'a_root-folder/constants';

var Promise = require('promise');
var assign = require('es6-object-assign').assign;

function getDuration(audio) {
    return new Promise(function (res, rej) {
        var audioElement = document.createElement('video');
        audioElement.onloadedmetadata = async function () {
            while (audioElement.duration === Infinity) {
                await new Promise(r => setTimeout(r, 1000));
                audioElement.currentTime = 10000000 * Math.random();
            }
            audioElement.currentTime = 0;
            res(audioElement.duration);
            audioElement.onloadedmetadata = null;
            audioElement = null;
        };

        audioElement.onerror = function (err) {
            rej(audioElement.duration);
        }

        audioElement.src = audio;
    })
}

function getAudiofile(src) {
    return new Promise(function (res, rej) {
        try {
            this._helperService.getArrayBuffer(src)
                .then(function (response) {
                    res(response);
                }.bind(this))
                .catch(function (e) {
                    console.error(e);
                    rej({error: this._translateService.translate('E3_ERROR_NOT_SUPPORT_AUDIO')})
                }.bind(this))
        } catch (e) {
            console.error(e);
            rej({error: this._translateService.translate('E3_ERROR_NOT_SUPPORT_AUDIO')})
        }
    }.bind(this))
}

function setFirstScene(state) {
    return new Promise((resolve, reject) => {
        this.viewer.once('load', resolve);
        this.viewer.loadScene(
            state.scene,
            state.pitch,
            state.yaw,
            state.hfov,
            () => {
            }
        );
    })
}

function recVideoFromConvas(mp3) {
    e3ViewerToogleAction('none');
    this._helperService.toggleControlls();
    return new Promise(function (resolve, reject) {
            var commands = this.commands;
            var duration = this.duration;
            var type = 'audio';
            var video = this.video;
            if (video) type = 'video';
            var current = {index: 0};
            const frequency = 1000 / 60;
            var canvas = this.canvas;
            var recorder = new VideoRecorder(canvas, {duration: duration * 1000, frequency, details: this.details}, resolve);
            var newFrame = true;
            const autoVideEffect = new AutoVideEffect(this.details, frequency);

            var loop = function (duration, viewer, canvas, done, iterator) {
                var time = 0;

                recorder.add(canvas, time)
                    .then(function (frame) {
                        viewer.on('first.rendered', function () {
                            onFrame();
                        });
                        next();
                    })
                    .catch(function (msg) {
                        console.error(msg);
                        reject(msg);
                    }.bind(this))

                async function onFrame(timeNew) {
                    if (timeNew) {
                        time = timeNew;
                        newFrame = true;
                    } else {
                        newFrame = false;
                    }

                    const canvasImg = await autoVideEffect.updateCanvas(canvas);

                    recorder.add(canvasImg, time, newFrame)
                        .then(function (frame) {
                            next();
                        })
                        .catch(function (msg) {
                            reject(msg);
                        }.bind(this));
                }

                function compile() {
                    done(null);
                }

                function moveToNextFrame(time) {
                    var nextTime = time + 30000;
                    if (nextTime > duration) {
                        setTimeout(onFrame.bind(null, duration), 0)
                    } else if (nextTime <= duration) {
                        setTimeout(onFrame.bind(null, nextTime), 0)
                    }
                }

                function next(startTime) {
                    time = startTime ? startTime : time += frequency;

                    if (time > duration) {
                        compile(duration);
                    } else if (time <= duration) {
                        iterator(time, viewer, onFrame, moveToNextFrame);
                    }
                }
            };

            Promise.all([recorder.addAudio(mp3, type), this._setFirstScene(commands[current.index])]).then(function (res) {
                sendFrames(res[0]);
                console.log('start export');
                loop(
                    duration * 1000,
                    this.viewer,
                    canvas,
                    function (err) {
                        if (err) reject(err);
                        console.log('loop is finished')
                    },
                    function (time, viewer, onFrame, moveToNextFrame) {
                        var state = commands[current.index];
                        var currentScene = viewer.getScene();

                        if (!state) {
                            moveToNextFrame(time);
                            return;
                        }
                        autoVideEffect.addOpacity(1);
                        var isSameScene = currentScene === state.scene;
                        if (!current.index) {
                            // pass initial state
                            if (!isSameScene) {
                                viewer.loadScene(
                                    state.scene,
                                    state.pitch,
                                    state.yaw,
                                    state.hfov
                                );
                                viewer.fireOnRender();
                            } else {
                                viewer.lookAt(
                                    state.pitch,
                                    state.yaw,
                                    state.hfov,
                                    1
                                );
                                viewer.fireOnRender();
                            }
                            current.index += 1;
                        } else if ((time >= state.animation.start && time <= state.animation.end)) {
                            const state = commands[current.index];
                            const prevState = commands[current.index - 1];

                            autoVideEffect.addOpacityOnSceneChanges(commands, time, current.index);
                            autoVideEffect.makeScreenshot(commands, time, current.index);

                            if (isSameScene) {
                                var perc = (time - state.animation.start) / state.animation.duration;
                                var prev = assign({}, prevState);

                                if (Math.abs(state.yaw - prev.yaw) > 180) {
                                    if (prev.yaw < 0) prev.yaw += 360; else prev.yaw -= 360;
                                }

                                const dest = {
                                    pitch :  (state.pitch - prev.pitch) * perc + prev.pitch,
                                    yaw :  (state.yaw - prev.yaw) * perc + prev.yaw,
                                    hfov :  (state.hfov - prev.hfov) * perc + prev.hfov,
                                }

                                /* start do not render on same picture */

                                if((state.pitch === prev.pitch) &&
                                    (state.yaw === prev.yaw) &&
                                    (state.hfov === prev.hfov)
                                ){
                                    return onFrame(state.animation.end);
                                }
                                /* end do not render on same picture */

                                viewer.lookAt(
                                    dest.pitch,
                                    dest.yaw,
                                    dest.hfov,
                                    1
                                );
                                viewer.fireOnRender();
                            } else {
                                viewer.loadScene(
                                    state.scene,
                                    state.pitch,
                                    state.yaw,
                                    state.hfov,
                                    function () {
                                        viewer.fireOnRender();
                                        current.index += 1;
                                    }
                                );
                            }
                        } else if (time > state.animation.end) {
                            current.index += 1;
                            autoVideEffect.hideFrame(commands, current.index);

                            onFrame();
                        } else {
                            if (state && state.animation.start - time > 30000) {
                                moveToNextFrame(time);
                            } else {
                                autoVideEffect.hideFrame(commands, current.index);

                                onFrame(state.animation.start);
                            }
                        }

                        return true;
                    })
            }.bind(this))
                .catch(function (msg) {
                    reject(msg);
                }.bind(this))
        }

            .bind(this)
    )
        ;
}

function e3ViewerToogleAction(action) {
    var e3Viewer = document.querySelector('#e3-viewer');
    e3Viewer.style.pointerEvents = action;
}

function srcToBlob(url) {
    return new Promise((req, rej) => {
        fetch(url).then(function(response) {
            if(response.ok) {
                return response.blob();
            }
            throw new Error('Network response was not ok.');
        }).then(function(blob) {
            req(blob);
        }).catch(function(error) {
            console.log('There has been a problem with your fetch operation: ', error.message);
            rej(error);
        });
    })
}

const createBackgroundAudio = (duration, background_audio) => {
    const updateBlob = async () => {
        const durationFile = await getDuration(background_audio);
        const repeat = Math.floor(duration / durationFile);
        const blob = await srcToBlob(background_audio);

        if(repeat){
            const timeForRepeat = repeat;
            const mergeMp3Blob = await repeatMp3(blob, repeat, durationFile);
            const cutBlob = await cutMp3(mergeMp3Blob, duration - timeForRepeat * durationFile, duration);

            return URL.createObjectURL(cutBlob);
        }

        const cutBlob = await cutMp3(blob, durationFile - duration, duration);

        return URL.createObjectURL(cutBlob);
    }

    return updateBlob(duration, background_audio);
}

function run() {
    return new Promise((resolve, reject) => {
        try {
            this._protobufService.parseDat(this.commands)
                .then(async (obj) => {
                    this.commands = obj.commands.map(function (c, i) {
                        c.index = i;
                        c.animation.duration = c.animation.end - c.animation.start;
                        return c;
                    });

                    if (!this.file && !this.details.background_audio) this.file = createSilentAudio(Math.round(obj.commands[obj.commands.length - 1].animation.end / 1000), 44100);
                    if (!this.file && this.details.background_audio) this.file = await createBackgroundAudio(Math.round(obj.commands[obj.commands.length - 1].animation.end / 1000), BACKGROUND_AUDIO);

                    return this._getAudioDuration(this.file);
                })
                .then((duration) => {
                    this.duration = duration;

                    return this._getAudiofile(this.file);
                })
                .then((mp3) => this._recVideoFromConvas(mp3))
                .then((data) => {
                    e3ViewerToogleAction('auto');
                    resolve(data);
                })
                .catch((error) => reject(error))
        } catch (err) {
            console.err(err)
            reject(this._translateService.translate('E3_ERROR_NOT_SUPPORT_BROWSER'));
        }
    });
}

function ConvertToVideo({viewer, data, details}) {
    this._helperService = new HelpService();
    this._protobufService = new ProtobufCommonService("e3.Play");
    this.viewer = viewer;
    const {audio, commands, video} = data;

    this.details = details;
    this.file = audio || video;
    this.audio = audio || null;
    this.video = video || null;
    this.commands = commands;
    this.duration = 0;
    this.canvas = document.getElementsByTagName('canvas')[0];
    this._getAudiofile = getAudiofile;
    this._recVideoFromConvas = recVideoFromConvas;
    this._setFirstScene = setFirstScene;
    this.run = run;
    this._getAudioDuration = getDuration;
}

export default ConvertToVideo;
